import {
    IClientRoleFilter,
    IClientUserAssociationFilter,
    IPlatformUsersFilter,
} from 'modules/settings/submodules/platformUsers/store/models';
import { SortingOrder } from 'shared/models/Order';
import { IStore } from 'store/configureStore';
import { IInfinityScrollState } from 'store/reducerUtils';
import { IClientUserAssociation } from 'store/entities/users/model';
import { getInfinityScrollSelectors } from 'store/utils/infinityScroll/selectors';

export const selectPlatformUsersState = (state: IStore) => {
    return state.modules.settings.platformUsers;
};

export const selectIsCreateUserModelOpened = (state: IStore) => {
    return selectPlatformUsersState(state).createUsers.isOpenCreateUserModal;
};

export const selectIsUserCreating = (state: IStore) => {
    return selectPlatformUsersState(state).createUsers.isUserCreating;
};

export const pageSize = 30;

export const selectUsers = (state: IStore) => {
    return selectPlatformUsersState(state).usersInfo.users;
};

export function selectUsersLoading(state: IStore): boolean {
    return selectPlatformUsersState(state)?.usersInfo?.isLoading || false;
}

export const selectTotalUsers = (state: IStore) => {
    return selectPlatformUsersState(state).usersInfo.totalUsers;
};

export const selectUserTableHasMoreUsers = (state: IStore) => {
    const totalUsers = selectTotalUsers(state);
    const users = selectUsers(state);

    if (totalUsers === undefined) {
        return true;
    }

    return users.length < totalUsers;
};

export const selectUserTableNextPageToLoad = (state: IStore) => {
    const users = selectUsers(state);
    return users.length / pageSize + 1;
};

export const selectPlatformUserFilter = (state: IStore): IPlatformUsersFilter => {
    const platformUsersState = selectPlatformUsersState(state);
    return platformUsersState.platformUserFilter;
};

export const selectIsClientUsersAssociationsCreating = (state: IStore) =>
    selectPlatformUsersState(state).clientUsersAssociations.isClientUserAssociationCreating;
export const selectIsClientUsersAssociationsCreateModalOpen = (state: IStore) =>
    selectPlatformUsersState(state).clientUsersAssociations.isModalOpen;

export const selectClientUserAssociationsState = (state: IStore): IInfinityScrollState<IClientUserAssociation> => {
    return selectPlatformUsersState(state).clientUsersAssociations.table;
};
export const clientUserAssociationSelectors = getInfinityScrollSelectors(selectClientUserAssociationsState);
export const selectClientUserAssociationFilter = (state: IStore): IClientUserAssociationFilter => {
    return selectPlatformUsersState(state).clientUsersAssociations.filter;
};

export const selectEditPlatformUserId = (state: IStore) => {
    return selectPlatformUsersState(state).editUsers.editUserId;
};
export const selectIsPlatformUserUpdating = (state: IStore) => {
    return selectPlatformUsersState(state).editUsers.isUserUpdating;
};

export const selectIsPlatformUserStatusUpdating = (state: IStore) => {
    return selectPlatformUsersState(state).isPlatformUserStatusUpdating;
};

export const selectClientRoleFilter = (state: IStore): IClientRoleFilter => {
    return selectPlatformUsersState(state).clientRoles.filter;
};
export const selectClientRoleSort = (state: IStore): SortingOrder => {
    return selectPlatformUsersState(state).clientRoles.sort;
};
export const selectCreateClientRoleModalOpen = (state: IStore) => {
    return selectPlatformUsersState(state).clientRoles.createModal;
};
export const selectIsClientRoleCreating = (state: IStore) => {
    return selectPlatformUsersState(state).clientRoles.isCreating;
};
export const selectEditClientRoleId = (state: IStore) => {
    return selectPlatformUsersState(state).clientRoles.editId;
};
export const selectIsClientRoleEditing = (state: IStore) => {
    return selectPlatformUsersState(state).clientRoles.isEditing;
};
export const selectIsClientRoleDeleting = (state: IStore) => {
    return selectPlatformUsersState(state).clientRoles.isDeleting;
};
